var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3834 0H20L15.3834 3.65055V0Z",
    fill: "url(#paint0_linear_2260_61308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25903 3.25983V11.1368H5.25012V5.25104H11.1356V3.25983H3.25903Z",
    fill: "url(#paint1_linear_2260_61308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3831V20L3.65034 15.3831H0Z",
    fill: "url(#paint2_linear_2260_61308)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8041 8.17961H11.9363V11.9375H8.17861V10.8053H10.8041V8.17961Z",
    fill: "url(#paint3_linear_2260_61308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2260_61308",
    x1: 10,
    y1: -1.42857,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887635"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2260_61308",
    x1: 10,
    y1: -1.42857,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887635"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2260_61308",
    x1: 10,
    y1: -1.42857,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887635"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2260_61308",
    x1: 10,
    y1: -1.42857,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887635"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxEdge);
export default __webpack_public_path__ + "static/media/boxEdge.5ea496136d89d800c5e21d72ea586960.svg";
export { ForwardRef as ReactComponent };